import styled from "styled-components";

export const TranslationFileManagementWrapper = styled.div`
  .headerContainer {
    justify-content: center !important;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .upload-hint {
    margin: 8px 0 0;
    font-size: 14px;
    color: #666;
    max-width: 520px;
  }

  .upload-submit-btn {
    cursor: pointer;
    font-family: inherit;

    &:disabled {
      opacity: 0.65;
      cursor: not-allowed;
      box-shadow: none;
    }

    &:disabled:hover {
      background: #5d78ff !important;
    }
  }

  .translation-toolbar--upload {
    margin-top: 0.5rem;
  }

  .upload-form-section {
    margin-top: 0.5rem;
  }

  .upload-form-section .form-control {
    border-color: #d8dce6;
    border-radius: 5px;
    font-size: 14px;

    &:focus {
      border-color: #5d78ff;
      box-shadow: 0 0 0 0.15rem rgba(93, 120, 255, 0.2);
    }
  }

  .upload-form-section .file-input-row .fieldLabel {
    color: #333;
    margin-bottom: 6px;
  }

  .action {
    display: flex;
    flex-direction: row;
    gap: 5px;
  }

  .accept {
    color: #5d78ff;
    border: 1px solid #5d78ff;
    font-weight: 700;
    font-size: 14px;
    background: white;
    letter-spacing: 1px;
    padding: 4px 22px;
    border-radius: 3px;
    word-break: normal;
  }

  .accept:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .file-input-row {
    margin-bottom: 1rem;
  }

  .fieldLabel {
    font-weight: 500;
  }

  .empty-languages-message {
    text-align: center;
    padding: 2rem;
    color: #666;
  }

  .translation-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 1.25rem;
    padding: 0 12px;
    flex-wrap: wrap;
  }

  .upload-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 38px;
    padding: 0 22px;
    border: none;
    border-radius: 6px;
    background: #5d78ff !important;
    color: #fff !important;
    font-weight: 700;
    font-size: 15px;
    text-decoration: none;
    white-space: nowrap;
    transition: background 0.2s ease, box-shadow 0.2s ease;

    &:hover:not(:disabled) {
      background: #4a65e8 !important;
      color: #fff !important;
      box-shadow: 0 2px 8px rgba(93, 120, 255, 0.35);
    }
  }

  .translation-toolbar__type {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-left: auto;
  }

  .translation-toolbar__label {
    font-size: 14px;
    font-weight: 600;
    color: #555;
    white-space: nowrap;
  }

  .translation-type-tabs {
    display: inline-flex;
    border: 1px solid #5d78ff;
    border-radius: 6px;
    overflow: hidden;
    background: #fff;
  }

  .type-tab {
    border: none;
    border-right: 1px solid #5d78ff;
    background: #fff;
    color: #5d78ff !important;
    font-weight: 600;
    font-size: 14px;
    line-height: 1.2;
    padding: 8px 20px;
    min-width: 88px;
    cursor: pointer;
    transition: background 0.2s ease, color 0.2s ease;

    &:last-child {
      border-right: none;
    }

    &:hover:not(.type-tab--active) {
      background: #f0f3ff;
    }

    &:focus-visible {
      outline: 2px solid #5d78ff;
      outline-offset: 2px;
      z-index: 1;
    }
  }

  .type-tab--active {
    background: #5d78ff !important;
    color: #fff !important;
  }
`;
